import React from 'react';
import {
  List,
  Filter,
  Datagrid,
  SearchInput,
  TextField,
  BooleanField,
  SelectInput,
  ReferenceInput,
  ReferenceField,
  useRedirect,
  TopToolbar,
  CreateButton,
  Button,
  useListContext,
  usePermissions,
} from 'react-admin';
import ListPagination from '../../components/ListPagination';
import { Permission } from '../../components';
import { PERMISSIONS } from '../../constants';
import { ResendEmailButton } from '../../components/EmailVerificationAlerts';
import { getChainId } from '../../lib';
import RecoveryIcon from '@mui/icons-material/Restore';

const ListActions = props => {
  const redirect = useRedirect();
  return (
    <TopToolbar>
      <CreateButton {...props} />
      <Button
        label="Recuperar"
        onClick={() => redirect('/_employees/recovery')}
        startIcon={<RecoveryIcon />}
        alignIcon="right"
        style={{ alignSelf: 'end', marginLeft: 16 }}
      />
    </TopToolbar>
  );
};

const PlacesUsersFilter = props => {
  const { permissions } = usePermissions();
  const isAdmin = permissions && permissions.includes(PERMISSIONS.ADMIN);
  const { filterValues } = useListContext();
  const placeFilter = isAdmin
    ? (filterValues.chainId ? { chainId: filterValues.chainId } : undefined)
    : { chainId: getChainId() };
  return (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
      {isAdmin && (
        <ReferenceInput
          source="chainId"
          reference="chains"
          sort={{ field: 'name', order: 'ASC' }}
          perPage={9999}
          alwaysOn
        >
          <SelectInput label="Rede" optionText="name" emptyText="Todas" />
        </ReferenceInput>
      )}
      <ReferenceInput
        source="placeId"
        reference="places"
        filter={placeFilter}
        sort={{ field: 'name', order: 'ASC' }}
        perPage={9999}
        alwaysOn
      >
        <SelectInput label="Posto" optionText="name" emptyText="Todos" />
      </ReferenceInput>
    </Filter>
  );
};

export default props => {
  const { permissions } = usePermissions();
  const isAdmin = permissions && permissions.includes(PERMISSIONS.ADMIN);
  const initialChainId = getChainId();
  const filterDefaultValues = isAdmin && initialChainId ? { chainId: initialChainId } : undefined;
  return (
  <List
    {...props}
    perPage={25}
    pagination={<ListPagination />}
    exporter={false}
    bulkActionButtons={false}
    filters={<PlacesUsersFilter />}
    filterDefaultValues={filterDefaultValues}
    title="Usuários de locais"
    actions={<ListActions />}
  >
    <Datagrid rowClick="show">
      <Permission permission={PERMISSIONS.ADMIN}>
        <ReferenceField
          label="Rede"
          reference="chains"
          source="chainId"
          link={false}
          emptyText=""
        >
          <TextField emptyText="" source="name" />
        </ReferenceField>
      </Permission>
      <ReferenceField
        label="Posto"
        reference="places"
        source="placeId"
        link={false}
        emptyText=""
      >
        <TextField emptyText="" source="name" />
      </ReferenceField>
      <TextField source="name" label="Nome" />
      <TextField source="login" label="Login" />
      <BooleanField source="emailVerified" label="Email verificado" />
      <ResendEmailButton label="Ações" />
      <Permission permission={PERMISSIONS.ADMIN}>
        <ReferenceField
          source="profileId"
          reference="profiles"
          label="Perfil"
        >
          <TextField source="name" />
        </ReferenceField>
      </Permission>
    </Datagrid>
  </List>
  );
}
